<template>
  <form>
    <div class="md-layout">
      <div class="md-layout-item md-small-size-100 md-size-20">
        <form-group label="Title" :validator-object="$v.user.title">
          <template v-slot:input>
            <md-select
              id="title"
              v-model="$v.user.title.$model"
              name="title"
              md-dense
            >
              <md-option value="Mr">Mr</md-option>
              <md-option value="Mrs">Mrs</md-option>
              <md-option value="Miss">Miss</md-option>
              <md-option value="Ms">Ms</md-option>
            </md-select>
          </template>
        </form-group>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-40">
        <form-group
          label="First Name"
          input-type="text"
          :validator-object="$v.user.first_name"
        ></form-group>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-40">
        <form-group
          label="Last Name"
          input-type="text"
          :validator-object="$v.user.last_name"
        ></form-group>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-50">
        <form-group
          label="Mobile Number"
          input-type="tel"
          :validator-object="$v.user.mobile_number"
        ></form-group>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-50">
        <form-group
          label="Email Address"
          input-type="email"
          :validator-object="$v.user.email"
        ></form-group>
      </div>
    </div>

    <div class="md-layout mt-3">
      <div class="md-layout-item md-size-100">
        <h6>Billing Address</h6>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-100">
        <form-group
          label="Business Address"
          input-type="text"
          :validator-object="$v.business.business_address"
        ></form-group>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-33">
        <form-group
          label="Suburb"
          input-type="text"
          :validator-object="$v.business.business_address_suburb"
        ></form-group>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-33">
        <form-group
          label="City"
          input-type="text"
          :validator-object="$v.business.business_address_state"
        ></form-group>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-33">
        <form-group
          label="Postal Code"
          input-type="number"
          :validator-object="$v.business.business_address_postcode"
        ></form-group>
      </div>
    </div>
    <div class="md-layout mt-3">
      <div class="md-layout-item md-size-100">
        <h6>Postal Address</h6>
      </div>
      <div class="md-layout-item md-size-100">
        <md-checkbox v-model="postalSameAddress">
          Same as Business Address
        </md-checkbox>
      </div>
    </div>
    <div v-if="postalSameAddress === false" class="md-layout">
      <div class="md-layout-item md-small-size-100 md-size-100">
        <form-group
          label="Postal Address"
          input-type="text"
          :validator-object="$v.business.postal_address"
        ></form-group>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-33">
        <form-group
          label="Suburb"
          input-type="text"
          :validator-object="$v.business.postal_address_suburb"
        ></form-group>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-33">
        <form-group
          label="City"
          input-type="text"
          :validator-object="$v.business.postal_address_state"
        ></form-group>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-33">
        <form-group
          label="Postal Code"
          input-type="number"
          :validator-object="$v.business.postal_address_postcode"
        ></form-group>
      </div>
    </div>
  </form>
</template>
<script>
import { mapGetters } from "vuex";
import businessModel from "@/models/business";
import FormGroup from "@/components/Forms/FormGroup";
import { email, maxLength, numeric, required } from "vuelidate/lib/validators";

export default {
  name: "BillingShippingForm",
  components: { FormGroup },
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      user: {
        title: "",
        first_name: "",
        last_name: "",
        email: "",
        mobile_number: ""
      },
      business: Object.assign({}, businessModel),
      postalSameAddress: false
    };
  },
  computed: {
    ...mapGetters(["authUser"])
  },
  validations: {
    user: {
      title: { required },
      first_name: {
        required,
        maxLength: maxLength(255)
      },
      last_name: {
        required,
        maxLength: maxLength(255)
      },
      email: {
        required,
        email
      },
      mobile_number: {
        required
      }
    },
    business: {
      business_address: {
        required,
        maxLength: maxLength(255)
      },
      business_address_suburb: {
        required,
        maxLength: maxLength(255)
      },
      business_address_state: {
        required,
        maxLength: maxLength(255)
      },
      business_address_postcode: {
        required,
        numeric,
        maxLength: maxLength(255)
      },
      postal_address: {
        required,
        maxLength: maxLength(255)
      },
      postal_address_suburb: {
        required,
        maxLength: maxLength(255)
      },
      postal_address_state: {
        required,
        maxLength: maxLength(255)
      },
      postal_address_postcode: {
        required,
        numeric,
        maxLength: maxLength(255)
      }
    }
  },
  mounted() {
    this.user = Object.assign(this.user, this.authUser);
    this.business = this.user.business;

    this.postalSameAddress = this.checkPostalSameAddress();
  },
  methods: {
    checkPostalSameAddress() {
      return (
        this.business.business_address === this.business.postal_address &&
        this.business.business_address_suburb ===
          this.business.postal_address_suburb &&
        this.business.business_address_state ===
          this.business.postal_address_state &&
        this.business.business_address_postcode ===
          this.business.postal_address_postcode
      );
    },
    setPostalAddressToSame() {
      this.business.postal_address = this.business.business_address;
      this.business.postal_address_suburb = this.business.business_address_suburb;
      this.business.postal_address_state = this.business.business_address_state;
      this.business.postal_address_postcode = this.business.business_address_postcode;
    },
    completed() {
      if (this.postalSameAddress) this.setPostalAddressToSame();

      return this.validate();
    },
    validate() {
      this.$v.$touch();
      return !this.$v.$invalid;
    }
  }
};
</script>
<style></style>
